import React from 'react'

const Staking = () => {
  return (
    <div>Staking Page</div>
  )
}
export default Staking;